<template>
  <div class="fillform" v-loading.fullscreen.lock="loading" v-loading="loading">
    <p>苏 格 兰 学 院 学 每 月 工 作 汇 报 表</p>
      <div class="mainHeader">

       <div class="oneline">
          <el-form :inline="true"  :model="formInline" class="demo-form-inline">
          <el-form-item label="授课教师">
              <el-input v-model="formInline.teacher" placeholder="授课教师"></el-input>
          </el-form-item>
          <el-form-item label="所在部门">
              <el-input v-model="formInline.teacherUnit" placeholder="教师所在单位"></el-input>
          </el-form-item>
                  <el-form-item label="教师职称">
              <el-input v-model="formInline.teacherTitle" placeholder="教师职称"></el-input>
          </el-form-item>
          <!-- <el-form-item label="年龄层次">
              <el-select v-model="formInline.teacherAgeLevel" placeholder="年龄层次">
              <el-option label="老(>55)" value="55"></el-option>
              <el-option label="中(35-55)" value="35"></el-option>
              <el-option label="青(20-35)" value="20"></el-option>
              </el-select>
          </el-form-item> -->
          </el-form>
          </div>
         <div class="oneline">
           <el-form :inline="true"  :model="formInline" class="demo-form-inline">
          <el-form-item label="考核年份">
          <el-select v-model="value" placeholder="请选择">
    <el-option
      v-for="item in year"
      :key="item"
      :label="item"
      :value="item">
    </el-option>
  </el-select>
  </el-form-item>
  <el-form-item label="考核月份">
  <el-select v-model="value2" placeholder="请选择">
    <el-option
      v-for="item in moun"
      :key="item"
      :label="item"
      :value="item">
    </el-option>
  </el-select>
       </el-form-item>   
          </el-form> 
      </div>
 
    </div>

           <div class="actionButton" v-loading="loading">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
              <!-- <el-divider></el-divider> -->
              <el-button type="primary" @click="downs">临时保存</el-button>
              <el-button type="primary" @click="dialogVisible=true">报告预览</el-button>
              <el-button type="primary" @click="onSubmit">确认提交</el-button>
              <el-button type="primary" @click="reset">清空再填</el-button>
              <!-- <el-button type="primary" @click="clear">取消</el-button> -->
              
  
          </el-form>
      </div>
     <div class="assessformTeacher" v-loading="loading">

        
          
             <div class="midform_T">
                  <div style="padding-top:0px;padding-left:40px;padding-bottom:1px">
                  <p>1</p></div>
                  <div style="padding-top:10px;padding-left:40px">
                  <p>2</p></div>
                   <div style="padding-top:10px;padding-left:40px">
                  <p>3</p></div>
                     <div style="padding-top:10px;padding-left:40px">
                    <p>4</p></div>
                    <div style="padding-top:10px;padding-left:40px">
                    <p>5</p></div>
                <div style="padding-top:10px;padding-left:40px">
                    <p>6</p></div>
                 <div style="padding-top:10px;padding-left:40px">
                    <p>7</p></div>
                   <div style="padding-top:10px;padding-left:40px">
                    <p>8</p></div>
             <div style="padding-top:10px;padding-left:40px">
                    <p>9</p></div>
              <div style="padding-top:10px;padding-left:40px">
                    <p>10</p></div>
                  <div style="padding-top:10px;padding-left:40px">
                    <p>11</p></div>
                    <div style="padding-top:10px;padding-left:40px">
                    <p>12</p></div>
                  <div style="padding-top:10px;padding-left:40px">
                    <p>13</p></div>

             <div style="padding-top:10px;padding-left:40px">
                    <p>14</p></div>
               <div style="padding-top:10px;padding-left:40px">
                    <p>15</p></div>
                        <div style="padding-top:10px;padding-left:40px">
                    <p>16</p></div>
             
             </div>
  
              
            <div class="Rightform_T">
                <div class="oneline" v-loading="loading">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="超课时数">
                         
                      </el-form-item>
                       <el-form-item>                     <el-input v-model="formInline.over_class" type="number" oninput="if(value.length>6)value=value.slice(0,6)" placeholder="规定课时数"></el-input>                </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.reality_class"  type="number" oninput="if(value.length>6)value=value.slice(0,6)" placeholder="实际课时数"></el-input>                </el-form-item>
                  </el-form>
                  </div>
               <div class="oneline">
                  <el-form :inline="true"  :model="formInline" class="demo-form-inline">
                      <el-form-item label="每周工作简报">
                         
                      </el-form-item>
                      <el-form-item>                     <el-input v-model="formInline.workBrief_times"  type="number" oninput="if(value.length>6)value=value.slice(0,6)" placeholder="本月提交周报（次数）"></el-input>                </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment2" placeholder="补充说明（可选）"></el-input>                </el-form-item>
                  </el-form>
               
                  </div>
                <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="节假日值班">
                        
                      </el-form-item>
                         <el-form-item>                     <el-input  type="number" oninput="if(value.length>7)value=value.slice(0,7)" v-model="formInline.holidays_duty_day_hour" placeholder="白天值班（小时数）"></el-input>                </el-form-item>
                            <el-form-item>                     <el-input v-model="formInline.holidays_duty_night_hour"  type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="晚上值班（小时数）"></el-input>                </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.holidays_duty_points_times"  type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="未到岗次数"></el-input>                </el-form-item>
                  </el-form>
                  </div>
                     <!-- <el-divider></el-divider> -->
               <div class="oneline">
                  <el-form :inline="true"  :model="formInline" class="demo-form-inline">
                      <el-form-item label="晚自习值班">
                       
                      </el-form-item>
                       <el-form-item>                     <el-input v-model="formInline.night_duty_times"  type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="晚自习值班（次数）"></el-input>                </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment4" placeholder="补充说明（可选）"></el-input>                </el-form-item>
                  </el-form>
                 
                  </div>
               <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="课外赛项辅导">
                         
                      </el-form-item>
                       <el-form-item>                     <el-input v-model="formInline.instruction_after_class_time"  type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="赛项辅导（课时数）"></el-input>                </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment5" placeholder="补充说明（可选）"></el-input>                </el-form-item>
                  </el-form>
   
                  </div>
               <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="第二课堂活动">
                        
                      </el-form-item>
                       <el-form-item>                     <el-input v-model="formInline.class_room_activities_time"  type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="参加第二课堂活动（课时数）"></el-input>                </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment6" placeholder="补充说明（可选）"></el-input>                </el-form-item>
                  </el-form>
                  </div>
               <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="文稿撰写（图文）">
         
                      </el-form-item>
                       <el-form-item>                     <el-input v-model="formInline.manuscript_writing_common_number"  type="number" oninput="if(value.length>9)value=value.slice(0,9)" placeholder="中文文稿（字数）"></el-input>                </el-form-item>
                         <el-form-item>                     <el-input v-model="formInline.manuscript_writing_both_number" placeholder="双语文稿（中文字数）" type="number" oninput="if(value.length>9)value=value.slice(0,9)"></el-input>                </el-form-item>
                           <el-form-item>                     <el-input v-model="formInline.manuscript_writing_nice_times" placeholder="每月最佳推文（篇数）" type="number" oninput="if(value.length>8)value=value.slice(0,8)"></el-input>                </el-form-item>
                        <!-- <el-form-item>                     <el-input v-model="formInline.comment7" placeholder="补充说明（可选）"></el-input>                </el-form-item> -->
                  </el-form>
                  </div>

                                  <!-- <el-divider></el-divider> -->
                 
               <div class="oneline">
                  <el-form :inline="true"  :model="formInline" class="demo-form-inline">
                      <el-form-item label="文稿翻译">
                        
                      </el-form-item>
                       <el-form-item>                     <el-input v-model="formInline.manuscript_translation_number" type="number" oninput="if(value.length>10)value=value.slice(0,10)" placeholder="中文文稿（字数）"></el-input>                </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment7" placeholder="补充说明（可选）"></el-input>                </el-form-item>
                  </el-form>
              
                  </div>
               <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="专题讲座">
                      
                      </el-form-item>
                       <el-form-item>                     <el-input v-model="formInline.seminar_times" type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="专题讲座（场次）"></el-input>                </el-form-item>
                      <el-form-item>                     <el-input v-model="formInline.comment8" placeholder="补充说明（可选）"></el-input>                </el-form-item>
                  </el-form>
                  </div>
             <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="听评课记录">
                   
                   </el-form-item>
                    <el-form-item>                     <el-input v-model="formInline.listen_class_times" type="number" oninput="if(value.length>5)value=value.slice(0,5)" placeholder="听评课并记录（次数）"></el-input>                </el-form-item>
                     <el-form-item>                     <el-input v-model="formInline.comment9" placeholder="补充说明（可选）"></el-input>                </el-form-item>
          
                  
                  </el-form>
                    <!-- <el-divider></el-divider> -->
           </div>

                        <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="教研活动">
                    
                   </el-form-item>
                   <el-form-item>                     <el-input v-model="formInline.attending_meetings_times" type="number" oninput="if(value.length>5)value=value.slice(0,5)" placeholder="教研活动（缺勤次数）"></el-input>                </el-form-item>
                     <el-form-item>                     <el-input v-model="formInline.comment10" placeholder="补充说明（可选）"></el-input>                </el-form-item>
      
                  </el-form>
                  
           </div>

                        <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="应邀代表学院参加社会活动">
                   
                   </el-form-item>
                     <el-form-item>                     <el-input v-model="formInline.public_activity_common_times" type="number" oninput="if(value.length>5)value=value.slice(0,5)" placeholder="应邀参加（次数）"></el-input>                </el-form-item>
                     <el-form-item>                     <el-input v-model="formInline.public_activity_nice_times" type="number" oninput="if(value.length>5)value=value.slice(0,5)" placeholder="应邀参加并发言（次数）"></el-input>                </el-form-item>
                  <el-form-item>
                      <el-input v-model="formInline.comment11" placeholder="补充说明（可选）"></el-input>
                  </el-form-item>
                  
                  </el-form>
                    <!-- <el-divider></el-divider> -->
           </div>

                       <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="课程外监考">
                       
                      </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.invigilate_times" type="number" oninput="if(value.length>5)value=value.slice(0,5)" placeholder="课程外监考（次数）"></el-input>                </el-form-item>
                      <el-form-item>                     <el-input v-model="formInline.comment12" placeholder="补充说明（可选）"></el-input>                </el-form-item>
                  </el-form>
                  </div>
  
                         <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="班主任">
                        
                      </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.teacher_duty_success_times" type="number" placeholder="规定职责数 （非班主任填0）"></el-input>                </el-form-item>
                      <el-form-item>                     <el-input v-model="formInline.teacher_duty_faile_times" type="number" placeholder="实际完成规定职责（项数）"></el-input>                </el-form-item>
                  </el-form>
                  </div>

                                         <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="指导学生大创项目">
                         
                      </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.occupational_guidance_times" type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="大创活动（次数）"></el-input>                </el-form-item>
                      <el-form-item>                     <el-input v-model="formInline.comment13" placeholder="活动名称及获奖情况）"></el-input>                </el-form-item>
                       <el-form-item>                     <el-input v-model="formInline.comment14" placeholder="补充说明（可选）"></el-input>                </el-form-item>
                  </el-form>
                  </div>

                                  <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="补充内容（可选）">
                         
                      </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.teacher_additional_score" type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="补充内容（分值）"></el-input>                </el-form-item>
                      <el-form-item>                     <el-input v-model="formInline.teacher_additional_comment" placeholder="补充文字说明"></el-input>                </el-form-item>
                       <el-form-item>                     <el-input v-model="formInline.teacher_additional_comment2" placeholder="其它补充说明（可选）"></el-input>                </el-form-item>
                  </el-form>
             </div>
  
        </div> 
      </div>
  
     
  
      <div class="metainfoFeedback" v-loading="loading">
      <el-form>
           <el-form-item label="情况说明及建议">
               
                  <el-input   type="textarea"  style="width:1100px"  :rows="3"   placeholder="请输入情况说明及建议（如需要）"   v-model="formInline.comment15"> </el-input>
          </el-form-item>
     </el-form>
    
     </div>


    <div class="uploadAttched" v-loading="loading">
     
   
      <el-form >
         <!-- <el-row>
         <el-col :span="12"><div class="grid-content bg-purple">      -->
           <el-form-item label="上传附加文件（可选）" span='8'>
            <el-upload
                class="upload-demo"
                drag
                action="https://jsonplaceholder.typicode.com/posts/"
                :auto-upload="false"
                :on-change="fileChange3"
                ref="uploadss"
                :limit="5"
                :on-remove="fileRemove3"
                width="40%"
              
                >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
                 
          </el-form-item>

 
     
     <!-- </el-col>
          </el-row>  -->
     </el-form>

     </div>
    
    
     

     <div class="actionButton2" v-loading="loading">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
              <!-- <el-divider></el-divider> -->
              <el-button type="primary" @click="downs">临时保存</el-button>
              <el-button type="primary" @click="dialogVisible=true">报告预览</el-button>
              <el-button type="primary" @click="onSubmit">确认提交</el-button>
              <el-button type="primary" @click="reset">清空再填</el-button>
 
          </el-form>
    </div>
      
  
    <el-dialog 
        :visible.sync="dialogVisible"
        width="90%"
        >
          <ComponentsSupervise :formInline="formInline" :fileList="fileList"></ComponentsSupervise>
          <el-button type="primary" @click="onSubmit">提交</el-button>
          <el-button type=" primary" @click="dialogVisible=false">取消</el-button>
    </el-dialog>
  </div>
  
  
  </template>
  
  <script>
    import ComponentsSupervise from '@/components/work/teacher/KpiDemo.vue'
     import { Notification } from 'element-ui';
  export default {
    components:{ComponentsSupervise},
    created(){
        this.getLectures()
    },
  data() {
        return {
            value: '',
        value2: '',
        year:[],
        moun:[],
          fileList7:[],
          fileList8:[],
          fileList:[],
         dialogVisible:false,
         loading:false,
         notifyPromise:Promise.resolve(),
          formInline: {
            over_class:'',
            workBrief_times:'',
            holidays_duty_day_hour:'',
            holidays_duty_night_hour:'',
            holidays_duty_points_times:'',
            night_duty_times:'',
            instruction_after_class_time:'',
            class_room_activities_time:'',
            manuscript_writing_common_number:'',
            manuscript_writing_both_number:'',
            manuscript_writing_nice_times:'',
            manuscript_translation_number:'',
            seminar_times:'',
            listen_class_times:'',
            attending_meetings_times:'',
            public_activity_common_times:'',
            public_activity_nice_times:'',
            invigilate_times:'',
            teacher_duty_success_times:'',
            teacher_duty_faile_times:'',
            occupational_guidance_times:'',
            teacher_additional_score:'',
            teacher_additional_comment:'',
            teacher_additional_comment2:'',
          comment1:'', 
          comment2:'',  
          comment3:'',  
          comment4:'',  
          comment5:'',  
          comment6:'',  
          comment7:'',  
          comment8:'',  
          comment9:'',  
          comment10:'',  
          comment11:'',  
          comment12:'',  
          comment13:'',   
          comment14:'',  
          comment15:'',  
          comment16:'',  
          kpi_time:'',
        },
      }

},methods:{
    onSubmit(){
        this.formInline.username=JSON.parse(localStorage.getItem('user')).username
    let boolean=this.getVis()
    if(boolean==false){
        return 
    }
         this.loading=true
         let config = { headers: { "Content-Type": "multipart/form-data" } };    
        // let config = {headers: { "Content-Type": "application/json" }}; 
        this.axios.post("/kpi/getKpi", this.getFormDate(),config)
        .then((resp) => {
          if (resp.data.status == 1) {
                 this.loading=false
            this.$message.success("添加成功");
          } else {
            this.$message.error("发生过错误"+resp.data.message);
            // alert("拿取数据失败");
            this.loading=false
          }
        })
        .catch((err) => {
          this.$message.error("出错");
          this.loading=false
        });

    },downs(){
       let userid= JSON.parse(localStorage.getItem("user")).userid
       localStorage.setItem('Supervise'+userid, JSON.stringify(this.formInline));
       if(localStorage.getItem("Supervise"+userid)!=null){
        this.$message.success("保存成功")
       }
    },getLectures(){
      this.getMonthList()
      this.getYearDateList()
        let userid= JSON.parse(localStorage.getItem("user")).userid
       if(localStorage.getItem("Supervise"+userid)!=null){
       this.formInline=JSON.parse(localStorage.getItem("Supervise"+userid)) 
       }
    },reset(){
        this.formInline={}
        let userid= JSON.parse(localStorage.getItem("user")).userid
        if(localStorage.getItem("Supervise"+userid)!=null){
             localStorage.removeItem("Supervise"+userid)
             this.$message.success("清空完成")
        }},
        getVis(){
            let boolean=true
            let demo=this.formInline  
            if(demo.teacher==null||demo.teacher==''){boolean=false  
            this.getmessage('请输入授课老师')}
            if(demo.teacherTitle==null||demo.teacherTitle==''){boolean=false  
            this.getmessage('请输入教师职称')}
            if(demo.holidays_duty_points_times==null||demo.holidays_duty_points_times==''){boolean=false 
            this.getmessage('请输入未到岗次数')}
            if(demo.teacherUnit==null||demo.teacherUnit==''){boolean=false 
            this.getmessage('请输入教师所在单位')}
           if(demo.over_class==null||demo.over_class==''){boolean=false 
            this.getmessage('请输入规定课时数')}
            if(demo.reality_class==null||demo.reality_class==''){boolean=false 
            this.getmessage('请输入实际课时数')}
            if(demo.workBrief_times==null||demo.workBrief_times==''){boolean=false 
            this.getmessage('请输入每周工作简报')}
            if(demo.holidays_duty_day_hour==null||demo.holidays_duty_day_hour==''){boolean=false 
            this.getmessage('请输入假日值班白天统计小时数')}
            if(demo.holidays_duty_night_hour==null||demo.holidays_duty_night_hour==''){boolean=false 
            this.getmessage('请输入假日值班晚上统计小时数')}
            if(demo.night_duty_times==null||demo.night_duty_times==''){boolean=false 
            this.getmessage('请输入晚自习值班统计次数')}
            if(demo.instruction_after_class_time==null||demo.instruction_after_class_time==''){boolean=false 
            this.getmessage('请输入课外赛项辅导统计多少课时')}
            if(demo.class_room_activities_time==null||demo.class_room_activities_time==''){boolean=false 
            this.getmessage('请输入第二课堂活动统计次数')}
            if(demo.manuscript_writing_common_number==null||demo.manuscript_writing_common_number==''){boolean=false 
            this.getmessage('请输入文稿撰写（图文）统计写了字数')}
            if(demo.manuscript_writing_both_number==null||demo.manuscript_writing_both_number==''){boolean=false 
            this.getmessage('请输入双语文稿计统计字数')}
            if(demo.manuscript_writing_nice_times==null||demo.manuscript_writing_nice_times==''){boolean=false 
            this.getmessage('请输入文稿撰写（图文）最佳次数')}
            if(demo.manuscript_translation_number==null||demo.manuscript_translation_number==''){boolean=false 
            this.getmessage('请输入文稿翻译统计字数')}
            if(demo.seminar_times==null||demo.seminar_times==''){boolean=false 
            this.getmessage('请输入专题讲座统计次数')}
            if(demo.listen_class_times==null||demo.listen_class_times==''){boolean=false 
            this.getmessage('请输入听评课记录统计次数')}
            if(demo.attending_meetings_times==null||demo.attending_meetings_times==''){boolean=false 
            this.getmessage('请输入教研活动缺勤次数')}
            if(demo.public_activity_common_times==null||demo.public_activity_common_times==''){boolean=false 
            this.getmessage('请输入应邀代表学院参加社会活动次数')}
            if(demo.public_activity_nice_times==null||demo.public_activity_nice_times==''){boolean=false 
            this.getmessage('请输入应邀代表学院参加社会活动，列为活动发言者次数')}
            if(demo.invigilate_times==null||demo.invigilate_times==''){boolean=false 
            this.getmessage('请输入课程外监考次数')}
            if(demo.teacher_duty_success_times==null||demo.teacher_duty_success_times==''){boolean=false 
            this.getmessage('请输入班主任完成学院班主任规定次数')}
            if(demo.teacher_duty_faile_times==null||demo.teacher_duty_faile_times==''){boolean=false 
            this.getmessage('请输入班主任未完成学院班主任规定次数')}
            if(demo.occupational_guidance_times==null||demo.occupational_guidance_times==''){boolean=false 
            this.getmessage('请输入指导学生大创项目次数')}
            if(demo.teacher_duty_success_times<demo.teacher_duty_faile_times){boolean=false 
            this.getmessage('班主任实际完成次数不能大于规定次数')}
            if(this.value2==null||this.value2==''){boolean=false 
            this.getmessage('请选择kpi月份')}
            return boolean
        },
        getmessage(message){
        //     const h = this.$createElement;
        //     this.$notify({
        //   title: '提示',
        //   type: 'warning',
        //   message: h('i', { style: 'color: red'}, message)
        // });

        this.notifyPromise = this.notifyPromise.then(this.$nextTick).then(()=>{
          Notification.warning({
          title: '提示',
          message: message,
          showClose: false
        });
    })
    

        },fileChange3(file, fileList){
        this.fileList7=fileList
      },fileRemove3(file, fileList){
        this.fileList7=fileList
      },getFormDate(){
        const fd = new FormData();
        fd.append("teacher",this.formInline.teacher)
        fd.append("teacherUnit",this.formInline.teacherUnit)
       fd.append("over_class",this.formInline.over_class)
       fd.append("teacherTitle",this.formInline.teacherTitle)
       fd.append("workBrief_times",this.formInline.workBrief_times)
       fd.append("holidays_duty_day_hour",this.formInline.holidays_duty_day_hour)
       fd.append("holidays_duty_night_hour",this.formInline.holidays_duty_night_hour)
       fd.append("holidays_duty_points_times",this.formInline.holidays_duty_points_times)
       fd.append("night_duty_times",this.formInline.night_duty_times)
       fd.append("instruction_after_class_time",this.formInline.instruction_after_class_time)
       fd.append("class_room_activities_time",this.formInline.class_room_activities_time)
       fd.append("manuscript_writing_common_number",this.formInline.manuscript_writing_common_number)
       fd.append("manuscript_writing_both_number",this.formInline.manuscript_writing_both_number)
       fd.append("manuscript_writing_nice_times",this.formInline.manuscript_writing_nice_times)
       fd.append("manuscript_translation_number",this.formInline.manuscript_translation_number)
       fd.append("seminar_times",this.formInline.seminar_times)
       fd.append("listen_class_times",this.formInline.listen_class_times)
       fd.append("reality_class",this.formInline.reality_class)
       fd.append("attending_meetings_times",this.formInline.attending_meetings_times)
       fd.append("public_activity_common_times",this.formInline.public_activity_common_times)
       fd.append("public_activity_nice_times",this.formInline.public_activity_nice_times)
       fd.append("invigilate_times",this.formInline.invigilate_times)
       fd.append("teacher_duty_success_times",this.formInline.teacher_duty_success_times)
       fd.append("teacher_duty_faile_times",this.formInline.teacher_duty_faile_times)
       fd.append("occupational_guidance_times",this.formInline.occupational_guidance_times)
       fd.append("teacher_additional_score",this.formInline.teacher_additional_score)
       fd.append("teacher_additional_comment",this.formInline.teacher_additional_comment)
       fd.append("teacher_additional_comment2",this.formInline.teacher_additional_comment2)
       fd.append("comment1",this.formInline.comment1)
       fd.append("comment2",this.formInline.comment2)
       fd.append("comment3",this.formInline.comment3)
       fd.append("comment4",this.formInline.comment4)
       fd.append("comment5",this.formInline.comment5)
       fd.append("comment6",this.formInline.comment6)
       fd.append("comment7",this.formInline.comment7)
       fd.append("comment8",this.formInline.comment8)
       fd.append("comment9",this.formInline.comment9)
       fd.append("comment10",this.formInline.comment10)
       fd.append("comment11",this.formInline.comment11)
       fd.append("comment12",this.formInline.comment12)
       fd.append("comment13",this.formInline.comment13)
       fd.append("comment14",this.formInline.comment14)
       fd.append("comment15",this.formInline.comment15)
       fd.append("comment16",this.formInline.comment16)
       fd.append("kpi_time",this.value+'-'+this.value2)
       this.fileList7.forEach((file) => {
          fd.append("fileList", file.raw);
       });
       return fd
      },getKpiTime(){
        if((this.value!=null&&this.value2!=null)){
          this.formInline.kpi_time=this.value+'-'+this.value2
        }
      },     getYearDateList(){
      var date = new Date()
    var Y = date.getFullYear()
    console.log(Y)
   let yearList=[]
    
   yearList.push(Y-1)
   yearList.push(Y)
   yearList.push(Y+1)
   this.value=Y
   this.year=yearList
       },
       getMonthList(){
        var date = new Date()
        var M = (date.getMonth() + 1)
        let mounList=[]
        for (let index = 1; index <13; index++) {
        mounList.push(index)  
        }
      this.moun=mounList
      // this.value2=M
       },
}
}
  </script>
  
<style scoped>
  
  .fillform{
  
      width:100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      border: 1px;
      padding-top: 30px;
  }
  .oneline{
      display: flex;
      flex-direction: column;
      /* height:100px; */
  }
  .singleinput{
      width:200px;
      height:20px ;
      margin-top: 15px;
      margin-left: 45px;
  }
  
  .multiinput{
      width:800px;
      height:80px ;
        margin-top: 15px;
      margin-left: 35px;
  }
  .metainfo
  {
      width:100%;
      height: 100px;
      display: flex;
      border: 2px;
      flex-direction: column;
  
  
  }
  .metainfo1
  {
      width:400px;
      height: 45px;
      display: flex;
      border: 1px;
  
  }
  .leftform_T{
      width:120px;
      height:980px;
        padding:10px;
      background-color:rgb(185, 212, 203);
      /* text-align:justify;
      vertical-align:middle; */
  }
  .leftform_S{
      width:270px;
      height:250px;
       padding:10px;
       padding-right:30px;
      background-color:rgb(202, 230, 219);
  }
  
  .leftform_All{
        width:270px;
      height:40px;
       padding:10px;
       padding-right:30px;
      background-color:rgb(107, 146, 130);
  }
  .midform_T{
      width:150px;
      height:980px;;
      padding:10px;
      background-color:rgba(153, 194, 197, 0.418);
  }
  .Rightform_T{
      width: 930px!important;
      height:980px;
      padding:10px;
      background-color:rgba(186, 230, 233, 0.418);
  }
  .Rightform_S{
      width:930px;
      height:250px;;
      padding:10px;
      background-color:rgba(186, 230, 233, 0.618);
  }
  .Rightform_All{
      width:980px;
      height:40px;;
      padding:10px;
      background-color:rgba(128, 161, 163, 0.418);
  }
  .midform_S{
     width:150px;
      height:400px;;
      padding:10px;
      background-color:rgba(153, 194, 197, 0.418);
  }
  .eachquestionform{
      width: 40%;
      height:40%;
      display: flex;
      flex-direction: column;
  }
  .assessformTeacher
  {
      display: flex;
      flex-direction: row;
      width: 100%;
      padding-top:0px;
  
      
  }
  .assessformstudent
  {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 40%;
  
  
      
  }
  .textvert{
      padding-top: 200px;
  }
  .metainfoFeedback
  {
      width:100%;
      height: 120px;
      display: flex;
       flex-direction: column;
      border: 1px;
      margin-top:15px;
  }

    .uploadAttched
  {
      width:100%;
      height: 150px;
      display: flex;
       flex-direction: column;
      border: 1px;
      margin-top:10px;
  }
  .actionButton{
  
      display: flex;
      padding-left:400px;
      padding-bottom: 20px;
      padding-top: 20px;
      
  }

  .actionButton2{
  
  display: flex;
  padding-left:400px;
  padding-bottom: 20px;
  padding-top: 150px;
  
}
  
  
  .item .el-form-item__label{
          color: #aaaa33;
      }
  .label-content .el-form-item__content{
          font-size: 20px;
          color: #aaaa33;
      }
  el-form-item >>>.el-form-item__label{
          color: #aaaa33;
      }
  .label-content .el-form-item__content{
          font-size: 20px;
          color: #aaaa33;
      }

.mainHeader{
        background-color: rgb(235, 226, 228);
        padding-top: 30px; 
    }
  
  </style>


// WEBPACK FOOTER //
// src/components/work/teacher/Kpi.vue